const buipType = {
  type: 'ConnectEd',
  key: 'BUIPType',
  value: 'withEnrollments'
};

export default buipType;



// WEBPACK FOOTER //
// ./app/models/buipType.js